import { makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  logo: {
    color: "White",
    fontWeight: 900,
  }
  
  
}));